import { useEffect, useState } from "react";

/**
 * A ticking "now" for relative times and rolling windows (ADR 136). State-backed so
 * render stays pure (react-hooks/purity forbids reading Date.now() during render):
 * the timestamp advances every `intervalMs` and each tick re-renders the consumer.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
